export default __webpack_public_path__ + "static/media/education-drive.47f6ccc8.jpg";